import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "regenerator-runtime/runtime.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useRef } from 'react';
import { Table, AccountingTabsHeader, Button } from 'components';
import { Modal } from 'components/UI';
import { showApiError } from 'utils';
import { getIssuedCreditsReference } from 'services';
import { tableWrap, tableTabsButtonsWrap } from 'styles';
import { issuedCreditsReferenceColumns } from './config';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IssuedCreditsReference = function IssuedCreditsReference() {
  var demoModalRef = useRef(null);

  var fetchIssuedCreditsReference = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tableOptions) {
      var _yield$getIssuedCredi, _yield$getIssuedCredi2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getIssuedCreditsReference(tableOptions);

            case 2:
              _yield$getIssuedCredi = _context.sent;
              _yield$getIssuedCredi2 = _slicedToArray(_yield$getIssuedCredi, 2);
              res = _yield$getIssuedCredi2[0];
              err = _yield$getIssuedCredi2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              showApiError(err);
              return _context.abrupt("return", [null, err]);

            case 9:
              return _context.abrupt("return", [res, null]);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchIssuedCreditsReference(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX(Modal, {
    ref: demoModalRef
  }, ___EmotionJSX("h4", {
    className: "mb1"
  }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"), ___EmotionJSX("p", {
    className: "mb1"
  }, "\u0411\u0438\u0445\u043C\u0435 \u0438\u0441\u043A\u0430\u043B\u0438 \u0434\u0430 \u0412\u0438 \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u043C, \u0447\u0435 \u0442\u043E\u0432\u0430 \u0435 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u0430 \u0441\u0440\u0435\u0434\u0430, \u043F\u043E\u0440\u0430\u0434\u0438 \u043A\u043E\u0435\u0442\u043E \u0444\u0430\u0439\u043B\u043E\u0432\u0435\u0442\u0435 \u043D\u0435 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u0441\u0432\u0430\u043B\u044F\u043D\u0438."), ___EmotionJSX("div", {
    css: function css(t) {
      return t.displayFlex({
        justify: 'flex-end'
      });
    }
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return demoModalRef.current.close();
    }
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"))), ___EmotionJSX("div", {
    css: tableTabsButtonsWrap
  }, ___EmotionJSX(Button, {
    small: true,
    type: "info",
    onClick: function onClick() {
      return demoModalRef.current.open();
    },
    leftIcon: {
      iconName: 'la la-file-excel',
      size: 20
    }
  }, "\u0415\u043A\u0441\u043F\u043E\u0440\u0442")), ___EmotionJSX(Table, {
    hasPagination: true,
    getDataMethod: fetchIssuedCreditsReference,
    columns: issuedCreditsReferenceColumns,
    emptyMessage: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438!",
    filterBar: function filterBar(data) {
      return ___EmotionJSX(AccountingTabsHeader, data);
    },
    margin: "0 2em"
  }));
};

export default IssuedCreditsReference;